import {logCaleMessages} from './analytics';
import {locationDetails} from '@adi/location-details';
import pageQuery from '@adi/page-query';
import {adiGigyaData} from '@adi/gigya_js/src/data'; //replace window.advance.gigya with this
import {pianoEnabled} from '../affiliate_settings';
import state from '../state';

/**
*  call cale for middleware auth
*  @param {Object} args - options object to send over
*  @param {Object} args.params - data to send over
*  @param {Object} args.access - post or get
*/
const callCale = async (args) => {
    try {
        if (!pianoEnabled) {
            throw new Error({response: "paywall not enabled"});
        }
    } catch (e) {
        return e;
    }

    // if GET request, attach args.params as query string otherwise, send in the body for POST requests
    const queryParam = args.access.match(/get/i) ? pageQuery.makeString(args.params) : "";
    const fetched = await fetch(`https://cale${locationDetails.tierSuffix}.advance.net/${args.endpoint}${queryParam}`, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: args.access,
        body: args.access.match(/post/i) && JSON.stringify(args.params),
    }).
        then(async (response) => {
            if (!response.ok) {
                window.tp.push([ "setCustomVariable", "middlewareerror", "true" ]);
                throw new Error(response.statusText);
            }
            const data = await response.text();
            const json = JSON.parse(data).results;
            logCaleMessages({
                response: json.response, message: json.messages,
            });
            return json;

        }).catch( (e) => {
            return e;
        });
    return fetched;
};

/*
 *  get params for cale access commands:
 *  gigya uid/uidsigature/signaturetimestamp and possible facebook token
 */
const getParams = () => {
    //generic for both equests
    if (!adiGigyaData.auth.user.UID) {
        throw new Error({response: "no uid"});
    }
    const params = {
        uid: adiGigyaData.auth.user.UID,
        uidsignature: adiGigyaData.auth.user.UIDSignature,
        signaturetimestamp: adiGigyaData.auth.user.signatureTimestamp,
    };

    // if facebook, send these params
    if (pageQuery.getValue('fb') ) {
        const account_linking_token = localStorage.getItem('account_linking_token');
        account_linking_token && (params.account_linking_token = account_linking_token);
    }
    return params;
};

/*
*   log error to cale logger
*   will get converted to query string-- requires key value pair.
*   @example callCaleLog({message:"there was a problem"})
*   {Object} message - message object to convert to query string
*   {String} message.key - the type of error
*   {String} message.value - the details of the error
*/
const callCaleLogError = (message) => {
    callCale({
        endpoint: `log`, access: 'get', params: message,
    });
    console.error(message);
};

/*
 * is this user a subscriber
 */
const callCaleAccess = () => callCale({
    endpoint: `${locationDetails.affiliate}/access`, access: 'get', params: getParams(),
});

/*
* create an mg2 stub account after account creation
*/
const callCaleEntitlements = () => callCale({
    endpoint: `${state.offerType || locationDetails.affiliate}/access`, access: 'post', params: getParams(),
});

/*
* subscribe to project text
*/
const callCaleTextSubscribe = (phone, campaignId) => callCale({
    endpoint: `${locationDetails.affiliate}/text_subscribe`, access: 'post', params: Object.assign(getParams(), {
        phone, campaign_id: campaignId,
    }),
});

export {callCaleAccess, callCaleEntitlements, callCaleTextSubscribe, callCaleLogError};
